import React from 'react';
import moment from 'moment';

export default class AccrualItemMobile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isElementVisible: [],

        }
        this.toggleVisibility = this.toggleVisibility.bind(this);
    }
    toggleVisibility(index) {
        let isElementVisible = this.state.isElementVisible.slice(0);
        isElementVisible[index] = !isElementVisible[index];
        this.setState({ isElementVisible });
    }
    render() {
        let accrualSummary = this.props.accrualSummary;
        //ap-paystubgrid-detail
        return (
            <div className="container-fluid ap-paystubgrid">
                {accrualSummary.map((item, index) => {
                    return (
                        <div className="row ap-paystubgrid-detail " key={item.accrualDescription + "_" + index}>
                            <div className="col-xs-12 text-left">
                                <span onClick={() => this.toggleVisibility(index)} className={this.state.isElementVisible[index] ? "fa fa-minus ap-good-color" : " fa fa-plus ap-good-color"}> </span> &nbsp;&nbsp;
                            <b> {item.accrualDescription} </b>
                            </div>
                            <hr />
                            <div className="col-xs-6 text-left">
                                <b>Total Accrued Hours</b>
                            </div>
                            <div className="col-xs-6 text-left">
                                <b>Logged Hours</b>
                            </div>
                            <div className="col-xs-6 text-left">
                                <b>{item.totalAccruedHours}</b>
                            </div>
                            <div className="col-xs-6 text-left">
                                <b>{item.loggedHours}</b>
                            </div>
                            <div className="col-xs-12 text-left">
                                <b>Available Hours</b>
                            </div>
                            <div className="col-xs-12 text-left">
                                <b>{item.availableHours}</b>
                            </div>
                            {
                                this.state.isElementVisible[index] ?
                                    <AccrualLogRowMobile accrualLogs={item.accrualLogs} group={item.accrualDescription} /> : null
                            }

                        </div>
                    );
                })}
            </div>
        );
    }

}
class AccrualLogRowMobile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        const accrualLogs = this.props.accrualLogs
        const group = this.props.group;
        let counter = 0;
        return (
            <div className="col-xs-12">
                {accrualLogs
                    .sort((a, b) => new Date(b.fromDate).getTime() - new Date(a.fromDate).getTime())
                    .map(item => {
                    return (
                        <div className="col-xs-12 ap-border-after" key={group + '_' + counter++}>
                            <div className="col-xs-6 text-left">
                                Date
                            </div>
                            <div className="col-xs-6 text-left">
                                Hours Logged
                            </div>
                            <div className="col-xs-6 text-left">
                                <b> {moment(item.fromDate).format('MM/DD/YYYY')}</b>
                            </div>
                            <div className="col-xs-6 text-left">
                                <b>{item.loggedHours}</b>
                            </div>

                            <div className="col-xs-6 text-left">
                                Status
                            </div>
                            <div className="col-xs-6 text-left">
                                Comments
                            </div>
                            <div className="col-xs-6 text-left">
                                <b>{item.pending == "Y" ? "Pending" : "Processed"}</b>
                            </div>
                            <div className="col-xs-6 text-left">
                                <b>{item.comment}</b>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}
